<template>
  <!-- eslint-disable-next-line vue/no-v-html -- highlight.js and escapeHtml both escape the source -->
  <pre class="sp-code"><code class="hljs" v-html="markup"></code></pre>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { useHostElement } from "#ce/composables/useHostElement";
import { highlightCode } from "./languages.js";
import { props as codeProps } from "./props.js";

const props = defineProps(codeProps);

const host = useHostElement();
const code = ref("");
const html = ref("");
const markup = computed(() => html.value || escapeHtml(code.value));

function escapeHtml(text) {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

let latestRequest = 0;

async function highlight() {
  const request = ++latestRequest;
  code.value = host.textContent;
  html.value = "";

  const highlighted = await highlightCode(code.value, props.language);

  if (request === latestRequest) {
    html.value = highlighted ?? "";
  }
}

onMounted(highlight);
watch(() => props.language, highlight);
</script>

<style>
:host {
  display: var(--sp-comp-code-display, block);
}

.sp-code {
  margin: var(--sp-comp-code-margin-block, 1em) 0;
  overflow-x: auto;
}

.hljs {
  display: block;
  padding: var(--sp-comp-code-padding, 0.5em);
  background: var(--sp-comp-code-background, #f0f0f0);
  color: var(--sp-comp-code-color, #444);
  font-family: var(--sp-comp-code-font-family, monospace);
}

.hljs-name,
.hljs-keyword {
  font-weight: bold;
}

.hljs-string,
.hljs-number {
  color: var(--sp-comp-code-string-color, #880000);
}

.hljs-literal {
  color: var(--sp-comp-code-literal-color, #78a960);
}

.hljs-comment {
  color: var(--sp-comp-code-comment-color, #888888);
}

.hljs-meta {
  color: var(--sp-comp-code-meta-color, #1f7199);
}
</style>
